module.exports = __webpack_public_path__ + "static/media/signature.3d9364d9.svg";